module.exports = __webpack_public_path__ + "img/P150T_weapon_61.82e02fd6.png";